import React from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import FallbackWrappedElement from './FallbackWrappedElement/FallbackWrappedElement';
import FileArchive from 'Routes/Public/FileArchive/FileArchive';
import SendFileArchive from 'Routes/Public/SendFileArchive/SendFileArchive';
import PatientCartable from 'Routes/Public/PatientCartable/PatientCartable';
import NobatPrefrences from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/NobatPrefrences/NobatPrefrences';
import WebAppSettings from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/DrawerContent/components/WebAppSettings/WebAppSettings';
import { Container, Stack } from '@mui/material';
import LanguageSelector from 'Global/Components/CommonComponents/BottomBar/Components/SettingDrawer/components/LanguageSelector/LanguageSelector';
import MoreColumSwitch from 'Global/Components/CommonComponents/MoreColumSwitch/MoreColumSwitch';

const GetNewTurn = React.lazy(() =>
  import('Routes/Public/GetNewTurn/GetNewTurn')
);
const Login = React.lazy(() =>
  import('Routes/Public/Login/Login')
);
const SignUp = React.lazy(() =>
  import('Routes/Public/SignUp/SignUp')
);
const TurnList = React.lazy(() =>
  import('Routes/Public/TurnList/TurnList')
);
const ChatApp = React.lazy(() =>
  import('Routes/Public/ChatApp/ChatApp')
);
const GetReportWithSMS = React.lazy(() =>
  import('Routes/Public/GetReportWithSMS/GetReportWithSMS')
);
const Survey = React.lazy(() =>
  import('Routes/Public/Survey/Survey')
);
const Advert = React.lazy(() =>
  import('Routes/Public/Advert/Advert')
);
const VerifyZarinPal = React.lazy(() =>
  import('Routes/Public/VerifyZarinPal/VerifyZarinPal')
);
const Wallet = React.lazy(() =>
  import('Routes/Public/Wallet/Wallet')
);
const PacsImages = React.lazy(() =>
  import('Routes/Public/PacsImages/PacsImages')
);
const Test = React.lazy(() =>
  import('Routes/Public/Test/Test')
);
const VerifySamanKish = React.lazy(() =>
  import('Routes/Public/VerifySamanKish/VerifySamanKish')
);

export const PublicRoutes = (
  AccessRoles,
  isWebAppSettingsEnabled,
  NobatPrefrences_label,
  WebAppSettingslabel
) => [
  {
    path: '/Login',
    component: (
      <FallbackWrappedElement>
        <Login />
      </FallbackWrappedElement>
    ),
    title: null,
  },
  {
    path: '/SignUp',
    component: (
      <FallbackWrappedElement>
        <SignUp />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('sign-up-navbar-title'),
  },
  // {
  //   path: "/Landing",
  //   component: <Landing />,
  //   title: null,
  // },
  {
    path: '/GetNewTurn',
    component: (
      <FallbackWrappedElement>
        <GetNewTurn />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-get-appointment'),
  },
  {
    path: '/TurnList',
    component: (
      <FallbackWrappedElement>
        <TurnList />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-appointments'),
  },
  {
    path: '/ChatApp',
    component: (
      <FallbackWrappedElement>
        <ChatApp />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-appointments'),
  },
  {
    path: '/Home/GetReport',
    component: (
      <FallbackWrappedElement>
        <GetReportWithSMS />
      </FallbackWrappedElement>
    ),
    title: null,
  },
  {
    path: '/NazarSanji/home/ItemForMobile',
    component: (
      <FallbackWrappedElement>
        <Survey />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('genral-public-route-title-survey'),
  },
  {
    path: '/home/ItemForMobile',
    component: (
      <FallbackWrappedElement>
        <Survey />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('survey-navbar-title-survey-form'),
  },
  {
    path: '/Adv',
    component: (
      <FallbackWrappedElement>
        <Advert />
      </FallbackWrappedElement>
    ),
    // title: FindLangKey('genral-public-route-title-survey'),
  },
  {
    path: '/VerifyZarinPal',
    component: (
      <FallbackWrappedElement>
        <VerifyZarinPal />
      </FallbackWrappedElement>
    ),
    // title: FindLangKey('genral-public-route-title-survey'),
  },
  {
    path: '/Wallet',
    component: (
      <FallbackWrappedElement>
        <Wallet />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-drawer-wallet-button'),
  },
  {
    path: '/PacsImages',
    component: (
      <FallbackWrappedElement>
        <PacsImages />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('main-menu-button-pacs-images'),
  },
  {
    path: '/TestPath',
    component: (
      <FallbackWrappedElement>
        <Test />
      </FallbackWrappedElement>
    ),
    title: 'تست',
  },
  {
    path: '/verifySamanKish',
    component: (
      <FallbackWrappedElement>
        <VerifySamanKish />
      </FallbackWrappedElement>
    ),
  },
  {
    path: '/FileArchive',
    component: (
      <FallbackWrappedElement>
        <FileArchive />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'genral-public-btn-label-download-file'
    ),
  },
  {
    path: '/SendFileArchive',
    component: (
      <FallbackWrappedElement>
        <SendFileArchive />
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'main-menu-button-patient-send-file'
    ),
  },
  {
    path: '/Cartable',
    component: (
      <FallbackWrappedElement>
        <PatientCartable />
      </FallbackWrappedElement>
    ),
    title: FindLangKey('patient-cartable-navbar-title'),
  },

  ...(isWebAppSettingsEnabled &&
  AccessRoles?.includes('admin')
    ? [
        {
          path: '/NobatPrefrences',
          component: (
            <FallbackWrappedElement>
              <NobatPrefrences />
            </FallbackWrappedElement>
          ),
          title: NobatPrefrences_label,
        },
        {
          path: '/WebAppSettings',
          component: (
            <FallbackWrappedElement>
              <WebAppSettings />
            </FallbackWrappedElement>
          ),
          title: WebAppSettingslabel,
        },
      ]
    : []),

  {
    path: '/Personalization',
    component: (
      <FallbackWrappedElement>
        <Container>
          <Stack>
            <LanguageSelector />
            <MoreColumSwitch />
          </Stack>
        </Container>
      </FallbackWrappedElement>
    ),
    title: FindLangKey(
      'genral-public-label-customization-settings'
    ),
  },
];
